const {REACT_APP_INSTANCE='test-dev'} = process.env;
module.exports = require(`../config/environment/${REACT_APP_INSTANCE}.json`);

console.log('REACT_APP_INSTANCE',REACT_APP_INSTANCE);